import { defaultCaseFilter } from 'constants/index';
import { convertCaseToFilterFormat } from 'utils/utils';
import { decode } from 'utils/encryptionUtils';

export const getDefaultFilter = (location, userContext, isCaseFileManager, isClientFileManager, isLeadFileManager) => {
  const urlParams = new URLSearchParams(location?.search || '');
  const sharedFolderFromUrl = urlParams.get('shared_folder') === 'true';

  const getSelectedFolderFromURL = () => {
    const breadCrumbRaw = urlParams.get('breadCrumb');
    if (!breadCrumbRaw) return '';
    try {
      const breadCrumbs = JSON.parse(decode(breadCrumbRaw));
      return Array.isArray(breadCrumbs) ? breadCrumbs[breadCrumbs.length - 1]?.value || '' : '';
    } catch (e) {
      return '';
    }
  };

  if (isCaseFileManager || isClientFileManager || isLeadFileManager) {
    const breadCrumb = location?.state?.breadCrumb;
    const isClientDashboard = userContext?.access_level === 'client' && location?.state?.isFromClientDashboard;
    const selectedFolder = breadCrumb?.value || getSelectedFolderFromURL();

    const filter = {
      fileType: '',
      tag: '',
      case: isClientFileManager ? convertCaseToFilterFormat(userContext?.clientSelectedCase) : '',
      selectedFolder,
      fileStatus: '',
    };

    if (sharedFolderFromUrl || isClientDashboard) {
      filter.shared_folder = true;
    }
    return filter;
  }

  const state = location?.state;
  const selectedFolder = state?.breadCrumb?.value || getSelectedFolderFromURL();

  const filter = {
    ...defaultCaseFilter,
    case: convertCaseToFilterFormat(userContext?.clientSelectedCase) || '',
    selectedFolder,
  };

  const file = state?.file;
  if (state?.isFromClientDashboard && file) {
    filter.case = { label: file?.case_name, id: file?.case_id };
  }
  if (sharedFolderFromUrl || (userContext?.access_level === 'client' && state?.isFromClientDashboard)) {
    filter.shared_folder = true;
  }
  if (state?.isFromDashboardSignatures) {
    filter.esignature_status = 'SIGNED';
  }
  return filter;
};
